import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import sidom from "../assets/images/sidom/fotos/SIDOM-LOGO_BLANCO.png";

import E1E from "../assets/images/sidom/svg/media-luna.svg";

import "../../node_modules/react-modal-video/css/modal-video.css";

export default function About() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);
  return (
    <>
      <div className="  bg-gradient-to-t from-sidom-blue via-sidom-blue to-sidom-orange ">
        <div data-aos="fade-up" data-aos-delay="100" className="container">
          <div className="flex  items-center mb-8  text-right">
            <img
              src={sidom}
              className="w-[300px] "
              alt="Logo institucional de Sidom"
            />
          </div>

          <div className="flex flex-col justify-center mt-8 items-center text-xl text-sidom-light">
            <div className="flex flex-col text-left leading-[1.3]  ">
              <h4 className="mb-8 ">
                Es la software factory líder en la gestión de comercio exterior,
                capaz de generar desarrollos tailor made completamente
                integrados con los sistemas locales de cada país.
              </h4>
              <h4 className="  ">
                Brindamos la Suite más completa de herramientas diseñada para
                simplificar las operaciones de gestión aduanera, comercio
                exterior y logística dentro de un mismo ecosistema
              </h4>
            </div>

            <div className="flex justify-center  mt-[65px] mb-[100px] items-center w-full  ">
              <img
                src={E1E}
                className="w-[70%]"
                alt="Gráfico decorativo media luna"
              />
            </div>
            <div className="w-full flex justify-center items-center">
              <div className="container border-b-[1px] border-white"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
